"use client";

import { usePathname, useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";

/**
 * Global navigation progress indicator
 * Shows a loading bar at the top when navigation starts
 */
export function NavigationProgress() {
	const pathname = usePathname();
	const searchParams = useSearchParams();
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		// Start loading
		setLoading(true);

		// Ultra-short delay for instant feedback
		const timer = setTimeout(() => {
			setLoading(false);
		}, 150);

		return () => clearTimeout(timer);
	}, [pathname, searchParams]);

	if (!loading) {
		return null;
	}

	return (
		<div className="fixed top-0 left-0 right-0 z-[9999] h-1 bg-transparent">
			<div className="h-full bg-primary animate-progress-bar" />
		</div>
	);
}
